/**
 * @param {string} key
 * @returns {string}
 */
export default function getLocalization(key) {
    if (
        typeof window.config === 'undefined' ||
        typeof window.config.search === 'undefined' ||
        typeof window.config.search.localization === 'undefined' ||
        typeof window.config.search.localization[key] === 'undefined'
    ) {
        return key;
    }

    return window.config.search.localization[key];
}
